import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ActionButton from 'components/buttons/action-button/ActionButton';
import { Form, FormField } from 'components/form';
import PromptExit from 'libs/router/prompt-exit/PromptExit';
import { ModalFrame, ModalFrameFooter, ModalFrameInner, ModalOpener } from 'components/modal';
import InputArray from 'components/inputs/input-array/InputArray';

import { inviteTeamMember } from '../reducers/teamMembers';
import { closeNotification } from 'redux-store/reducers/common-reducer';

import { isArrayOfEmail, isRequired } from 'utils/validators';
import { t } from 'utils/language';
import { getEntityFromOrganization } from 'utils/view';

export class InviteMembersModal extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    organizationId: PropTypes.number.isRequired,
    dispatch: PropTypes.func.isRequired,
    asAdmin: PropTypes.bool,
    currentOrganization: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.state = this.getDefaultState();
  }

  getDefaultState() {
    return {
      email: [],
      isModified: false
    };
  }

  closeModal(invitedUser = null) {
    const { onClose, dispatch } = this.props;

    this.setState(this.getDefaultState());
    dispatch(closeNotification());

    onClose(invitedUser);
  }

  handleTextInput = (value, fieldName) => {
    this.setState({
      [fieldName]: value,
      isModified: true
    });
  };

  handleInvite = () => {
    const { dispatch, organizationId, asAdmin } = this.props;
    const payload = {
      emails: this.state.email
    };

    dispatch(inviteTeamMember(organizationId, payload, asAdmin))
      .then((invitedUser) => this.closeModal(invitedUser));
  };

  handleClose = () => {
    this.closeModal();
  };

  render() {
    const { open, currentOrganization } = this.props;
    const { isModified } = this.state;
    const state = this.state;

    const profile = getEntityFromOrganization(currentOrganization);

    return (
      <ModalOpener
        open={open}
        onClose={this.handleClose}
      >
        <ModalFrame
          title={t('invite_team_members_modal_title', { profileName: profile?.firstName })}
        >
          {
            isModified &&
              <PromptExit type="modal" />
          }
          <ModalFrameInner
            narrowContent
          >
            <Form onSubmit={this.handleInvite}>
              <FormField
                label={t('invite_email')}
                labelType="highlighted"
                direction="column"
                fontSize="small"
                showRequiredMark
                showValidationIcon={false}
                validators={[
                  isRequired(state.email),
                  isArrayOfEmail(state.email)
                ]}
                helpNote={t('invite_email_help_note')}
              >
                <InputArray
                  value={state.email || []}
                  max={10}
                  onChange={(items) => this.handleTextInput(items, 'email')}
                />
              </FormField>
              <ModalFrameFooter>
                <ActionButton
                  color="tertiary"
                  onClick={this.handleClose}
                >
                  {t('action_button_cancel')}
                </ActionButton>
                <ActionButton
                  type="submit"
                >
                  {t('invite_team_members_button')}
                </ActionButton>
              </ModalFrameFooter>
            </Form>
          </ModalFrameInner>
        </ModalFrame>
      </ModalOpener>
    );
  }
}

const mapStateToProps = ({ organizations }, { organizationId }) => ({
  currentOrganization: organizations.list.find(o => o.id == organizationId)
});

export default connect(mapStateToProps)(InviteMembersModal);
